<template>

  <t-page>


    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage"
                 msg-return-gender-feminine>


      <template #search>


        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                  :to="currentPage.name + '-form-new'" primary/>


        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :fields-custom="entityFieldCustomized('page')"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form">

          <t-input-search v-model="form.roleId"
                          :options="roleOptions"
                          label="Função" select/>

        </t-content-header-search-default>

      </template>

      <t-table :show="checkViewListTableDefault()" @reload="reloadPageList()"
               :filtered="checkIsFiltered()"
               :busy="!pageListIsLoaded"
               :items="request.content"
               :user-auth="userAuth"
               :fields="userAuth.viewFields"
               link-primary-column="employeeCodeLabel"
               primary-key-column="employeeNumber"/>


    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import roleService from "@/services/modules/employee/Role.service";

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  name: 'Employee',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      enableGeneralFields: true,
      form: {
        roleId: 0,
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      roleOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

      await roleService.selectList().then((list) => {
        this.roleOptions = list
      }).catch(error => this.responseError(error))

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>
